/**
 * SocialMediaStoryService
 * Service for SocialMediaStory entity operations
 * Route: api/socialmedia/stories
 */
import { BaseService } from '../base/BaseService';
/**
 * SocialMediaStoryService
 * Handles social media story queries and metrics
 */
export class SocialMediaStoryService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SocialMediaStoryService.DEFAULT_SERVICE_PATH,
            basePath: SocialMediaStoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY ID ====================
    /**
     * Get story by ID
     * GET api/socialmedia/stories/{id}
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Story ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get story by ID with full response
     */
    getByIdRaw(id) {
        const endpoint = this.getEndpoint('get', id);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY ACCOUNT ====================
    /**
     * Get stories by account ID
     * GET api/socialmedia/stories/account/{accountId}?includeExpired={includeExpired}
     */
    async getByAccount(accountId, includeExpired = false) {
        const response = await this.getByAccountRaw(accountId, includeExpired);
        return response.data ?? [];
    }
    /**
     * Get stories by account ID with full response
     */
    getByAccountRaw(accountId, includeExpired = false) {
        const endpoint = this.getEndpoint('by-account', `account/${accountId}`);
        const url = this.buildUrl(endpoint);
        const urlWithParams = `${url}?includeExpired=${includeExpired}`;
        return this.http.get(urlWithParams);
    }
    // ==================== GET ACTIVE STORIES ====================
    /**
     * Get active stories for an account
     * GET api/socialmedia/stories/account/{accountId}/active
     */
    async getActiveStories(accountId) {
        const response = await this.getActiveStoriesRaw(accountId);
        return response.data ?? [];
    }
    /**
     * Get active stories with full response
     */
    getActiveStoriesRaw(accountId) {
        const endpoint = this.getEndpoint('active', `account/${accountId}/active`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
SocialMediaStoryService.DEFAULT_SERVICE_PATH = 'social-media';
SocialMediaStoryService.BASE_PATH = 'api/socialmedia/stories';
//# sourceMappingURL=SocialMediaStoryService.js.map